// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"93facb4e","455":"f16ddea7","977":"cee366f1"}[chunkId] + ".chunk.js";
};